import React from "react";
import { useSelector } from "react-redux";
import {
  getDashboardFilters,
  getWorkbookProperty,
  getL1SheetProperty,
  getL2SheetProperty,
} from "../WorkbookSlice";
import Aside3Filter from "../components/Aside3Components/Aside3Filter";

export default function FilterItem({
  dashboardSheetID,
  isFilterVisibleInDashboard,
  droppedSheetsArray = [],
  currentSheetID,
  currentSheetType,
  dashboardType
}) {
  // // console.log(dashboardSheetID);
  // console.log(currentSheetType);
  // // console.log(droppedSheetsArray);
  // // console.log(currentSheetID);
  const sheetsFilters = useSelector((state) =>
    getL2SheetProperty(state, currentSheetID, "query", "filters")
  );
  // console.log(sheetsFilters);

  const visibleDashboardFilter = useSelector(
    (state) =>
      droppedSheetsArray
        .map((sheet) => {
          const { Sheetid } = sheet;
          return getDashboardFilters(state, dashboardSheetID, Sheetid);
        })
        .flat() // Flatten the resulting array
  );

  // console.log(visibleDashboardFilter);
  const sheetsVisibleFilter =
    sheetsFilters != undefined &&
    sheetsFilters.length &&
    sheetsFilters.filter((sFilter) => sFilter.visibleFilter === true);
  // console.log(sheetsVisibleFilter);
  const commonFilters = useSelector((state) =>
    getWorkbookProperty(state, "commonFilters")
  );
  if (currentSheetType === "dashboard") {
    return (
      <div className="w-full">
        {visibleDashboardFilter.length
          ? visibleDashboardFilter.map((item, index) => {
              return (
                <Aside3Filter
                  item={item}
                  index={index}
                  Sheetid={item.Sheetid}
                  key={item.nanoId}
                  reduxFilterType={item.filterType}
                  filterArray={visibleDashboardFilter}
                  dashboardSheetID={dashboardSheetID}
                  isFilterVisibleInDashboard={isFilterVisibleInDashboard}
                  commonFilters={commonFilters}
                  currentSheetType={currentSheetType}
                  dashboardType={dashboardType}
                />
              );
            })
          : null}
      </div>
    );
  }
  if (currentSheetType === "chart") {
    return (
      <div className="w-full">
        {sheetsVisibleFilter.length
          ? sheetsVisibleFilter.map((item, index) => {
              return (
                <Aside3Filter
                  item={item}
                  index={index}
                  Sheetid={item.Sheetid}
                  key={index}
                  reduxFilterType={item.filterType}
                  filterArray={sheetsVisibleFilter}
                  dashboardSheetID={dashboardSheetID}
                  isFilterVisibleInDashboard={isFilterVisibleInDashboard}
                  commonFilters={commonFilters}
                  currentSheetType={currentSheetType}
                />
              );
            })
          : null}
      </div>
    );
  }
}
